export default `
<div class="course-track-quiz">
  <course-track-quiz-progress-bar step="$ctrl.step" questions="$ctrl.quiz.questions" aria-label="Question {{$ctrl.step + 1}} out of {{$ctrl.quiz.questions.length}}" tabindex="0"></course-track-quiz-progress-bar>
  <form id="quiz_for_track_{{$ctrl.courseTrack.id}}" ng-submit="$ctrl.submitQuiz()">
      <course-track-quiz-question step="$ctrl.step" previous-question="$ctrl.quiz.questions[$index - 1]" next-question="$ctrl.quiz.questions[$index + 1]" user-choice="$ctrl.userChoice" course-track="$ctrl.courseTrack" question-number="$index" question="question" ng-repeat="question in $ctrl.quiz.questions" submit-quiz="$ctrl.submitQuiz"></course-track-quiz-question>
  </form>
</div>
`;
